import { useMediaQuery, useTheme } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFetch } from "@4uhub/lib4uhub";
import Loading from "../Loading";
import NoData from "../UI/NoData";
import { ITopMedSchedule } from "../../models/topmed";
import { topmedSchedules } from "../../services/topmedSchedule.service";
import TopMedScheduleList from "./TopMedScheduleList/TopMedScheduleList";
import TopMedSchedulesTable from "./TopMedSchedulesTable/TopMedSchedulesTable";
import { ITopMedSchedulesProps } from "./models";

const Schedules: React.FC<ITopMedSchedulesProps> = ({ historic = false }) => {
  const [schedules, setSchedule] = useState<ITopMedSchedule[]>([]);

  const [refresh, setRefresh] = useState(0);

  const { t } = useTranslation();

  const { sendRequest, loading } = useFetch(topmedSchedules);

  const { breakpoints } = useTheme();

  const mobile = useMediaQuery(breakpoints.down("md"));

  const refreshHandler = useCallback(() => {
    setRefresh((prev) => prev + 1);
  }, []);

  const fetch = useCallback(async () => {
    const { data, success } = await sendRequest({
      historic,
    });

    if (data && success) {
      setSchedule(data);
    }
  }, [sendRequest, historic]);

  useEffect(() => {
    fetch();
  }, [fetch, refresh]);

  if (loading) {
    return <Loading />;
  }

  if (schedules.length === 0) {
    return <NoData message={t("page.schedules.home.noFound")} />;
  }

  if (mobile) {
    return <TopMedScheduleList data={schedules} onRefresh={refreshHandler} />;
  }

  return <TopMedSchedulesTable data={schedules} onRefresh={refreshHandler} />;
};

export default memo(Schedules);
